export default __webpack_public_path__ + "static/media/customerIcon.14105e78.svg";